// The event terms a buyer sets, shared by the editing panel (NotesTermsTab) and the
// Overview's Terms card (Lane 1387, Ryan 2026-10-05: "Terms and documents" left the
// header; the terms show on the Overview and the documents have their own tab). One
// list of fields and labels, one rule for which terms are shown, so the card and the
// panel can never disagree.
import { formatDate } from './sourcingApi';
import { formatDueAt } from '../sourcing-portal/portalView';

// The one-line fields: key, label, placeholder in the editor.
export const TERM_FIELDS = [
  ['currency', 'Currency', 'USD'],
  ['payment_terms', 'Payment terms', 'Net 60'],
  ['incoterms', 'Delivery terms (Incoterms)', 'FCA supplier plant'],
  ['offer_validity_days', 'Offers valid for (days)', '90'],
  ['due_date', 'Offers due', ''],
];

// The text fields, below the one-line fields.
export const DESCRIPTION_LABEL = 'What suppliers read about this event';
export const DELIVERY_NOTES_LABEL = 'Delivery notes';

// The terms on screen: after publish, a change in progress shows its own terms (slice
// 2E); otherwise the event's.
export function shownTerms(summary) {
  const amendment = summary.status !== 'draft' ? summary.amendment : null;
  return { terms: (amendment ? amendment.terms : summary.terms) || {}, amendment };
}

// After publish the round's due time is the only deadline (PLAN 8.1): the proposed due
// date in the terms is never shown again.
export function termFields(summary) {
  return summary.status !== 'draft' ? TERM_FIELDS.filter(([key]) => key !== 'due_date') : TERM_FIELDS;
}

// The due line after publish: "Oct 9, 2026, 5:00 PM PDT, round 2. The round closed ...".
export function quotesDueText(summary) {
  const round = summary.round || {};
  return `${round.due_at ? formatDueAt(round.due_at) : 'No due time set'}`
    + `${summary.current_round ? `, round ${summary.current_round}` : ''}`
    + `${round.closed_at ? `. The round closed ${formatDueAt(round.closed_at)}.` : ''}`;
}

// The rows of the Overview's Terms card: [key, label, value text], every term the panel
// shows, in the panel's order. A term the buyer has not set reads "Not set".
export function termRows(summary) {
  const { terms } = shownTerms(summary);
  const text = (value) => (value === null || value === undefined || String(value).trim() === ''
    ? null : String(value));
  const rows = [];
  if (summary.status !== 'draft') rows.push(['quotes_due', 'Quotes due', quotesDueText(summary)]);
  termFields(summary).forEach(([key, label]) => {
    const value = text(terms[key]);
    rows.push([key, label, key === 'due_date' && value ? formatDate(value) : value]);
  });
  rows.push(['supplier_description', DESCRIPTION_LABEL, text(terms.supplier_description)]);
  rows.push(['delivery_notes', DELIVERY_NOTES_LABEL, text(terms.delivery_notes)]);
  return rows.map(([key, label, value]) => [key, label, value === null ? 'Not set' : value]);
}
